import { ADMIN_HIGH, ADMIN_LOW, ADMIN_OWNER, SUPER_ADMIN } from "./constants/bitwiseOperations";

export default {
    items: [
        {
            lang_key: "dashboard",
            name: "Resumen",
            url: "/dashboard",
            icon: "icon-speedometer",
            type: ADMIN_HIGH
        },
        {
            lang_key: "map",
            name: "Mapa",
            icon: "icon-map",
            url: "/map",
            type: ADMIN_LOW
        },
        {
            lang_key: "orders",
            icon: "icon-bag",
            name: "Órdenes",
            children: [
                {
                    lang_key: "orders",
                    name: "Órdenes Generales",
                    url: "/order-management",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "orders",
                    name: "Órdenes sin pagar",
                    url: "/orders-unpaid",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "orders",
                    name: "Órdenes sin iniciar",
                    url: "/orders-not-started",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "orders",
                    name: "Órdenes sin repartidor",
                    url: "/orders-unassigned",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "orders",
                    name: "Órdenes canceladas",
                    url: "/orders-cancelled",
                    type: ADMIN_LOW
                },
            ],
        },
        // {
        //     lang_key: "orders",
        //     icon: "icon-bag",
        //     name: "Órdenes",
        //     url: "/order-management",
        //     type: ADMIN_LOW
        // },
        {
            lang_key: "create-order",
            icon: "icon-basket-loaded",
            name: "Crear orden",
            url: "/create-order",
            type: ADMIN_OWNER
        },
        {
            lang_key: "clients",
            name: "Usuarios (Clientes)",
            icon: "icon-people",
            url: "/clients-management",
            type: ADMIN_HIGH
        },
        {
            lang_key: "",
            name: "Aliados",
            icon: "icon-layers icons",
            children: [
                {
                    lang_key: "branchs-groups",
                    name: "Grupos de comercios",
                    url: "/branchs",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "branches",
                    name: "Comercios",
                    url: "/branchs-list",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "branchs-categories",
                    name: "Categorías de comercio",
                    url: "/branch-category-company",
                    type: ADMIN_HIGH
                },
            ],
        },
        {
            lang_key: "inventory",
            name: "Inventario",
            icon: "icon-book-open",
            children: [
                {
                    lang_key: "goods",
                    name: "Productos",
                    url: "/goods-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "categories",
                    name: "Categorías",
                    url: "/categories-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "attributes",
                    name: "Variantes",
                    url: "/properties-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "goods-types",
                    name: "Tipos de productos",
                    url: "/good-type-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "eta",
                    name: "Eta",
                    url: "/eta",
                    type: ADMIN_HIGH
                },
            ],
        },
        {
            lang_key: "",
            name: "Roles",
            icon: "icon-people",
            children: [
                {
                    lang_key: "admins",
                    name: "Administradores",
                    url: "/admins-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "providers",
                    name: "Repartidores",
                    url: "/provider-management",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "admin_types",
                    name: "Tipos de administrador",
                    url: "/admin-types-management",
                    type: ADMIN_HIGH
                },
            ],
        },
        {
            lang_key: "",
            name: "Marketing",
            icon: "icon-magic-wand",
            children: [
                {
                    lang_key: "banners",
                    name: "Banners",
                    url: "/banners",
                    type: ADMIN_LOW
                },
                {
                    ang_key: "notifications",
                    name: "Notificaciones masivas",
                    url: "/list-send-notifications",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "coupons",
                    name: "Cupones",
                    url: "/coupons",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "promo",
                    name: "Promociones",
                    url: "/promos",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "section",
                    name: "Secciones",
                    url: "/sections",
                    type: ADMIN_LOW
                },
                {
                    lang_key: "featured-products",
                    name: "Productos destacados",
                    url: "/featured-products",
                    type: ADMIN_LOW
                },
            ],
        },
        {
            lang_key: "reports",
            name: "Reportes",
            url: "/reports",
            icon: "icon-docs",
            type: ADMIN_LOW
        },
        {
            lang_key: "",
            name: "Finanzas",
            icon: "icon-wallet",
            children: [
                {
                    lang_key: "billing",
                    name: "Balance",
                    url: "/company-billings",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "billing",
                    name: "Mis cobros",
                    url: "/company-charges",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "branch-invoices",
                    name: "Facturas de comercio",
                    url: "/branch-invoices",
                    type: ADMIN_LOW
                }
            ],
        },
        {
            lang_key: "",
            name: "Flotas",
            icon: "fa fa-car",
            children: [
                {
                    lang_key: "fleets",
                    name: "Flotas",
                    url: "/fleets",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "service_suppliers",
                    name: "Proveedores de servicio",
                    url: "/service-suppliers",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "service_profiles",
                    name: "Perfiles de servicio",
                    url: "/service-profiles",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "service_charges",
                    name: "Cargos de servicio",
                    url: "/service-charges",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "fleet_associations",
                    name: "Asociaciones",
                    url: "/fleet-associations",
                    type: ADMIN_HIGH
                },
            ],
        },
        {
            lang_key: "webhooks",
            icon: "icon-globe",
            name: "Webhooks",
            url: "/webhooks",
            type: ADMIN_HIGH,
        },
        {
            lang_key: "api_partners",
            name: "Socios de Integración",
            url: "/api-partners",
            icon: "fa fa-handshake-o",
            type: ADMIN_HIGH,
        },
        {
            lang_key: "company",
            name: "Configuración",
            url: "/settings",
            icon: "fa fa-gears",
            type: ADMIN_HIGH,
        },
        {
            lang_key: "",
            name: "Estadísticas",
            icon: "icon-speedometer icons",
            children: [
                {
                    lang_key: "branch_group",
                    name: "Comercios",
                    url: "/branch-statistics",
                    type: ADMIN_HIGH
                },
                {
                    lang_key: "branch",
                    name: "Grupos de comercio",
                    url: "/branch-group-statistics",
                    type: ADMIN_HIGH
                }
            ],
        },
    ].filter(item => {
        if(process.env.REACT_APP_ENV.toUpperCase() === "PRODUCTION"){
            return item.lang_key !== "create-order";
        }
        return item.name !== "Estadísticas";
    })
};



// WEBPACK FOOTER //
// ./src/_navOwner_es.js